import { useEffect, useState } from 'react';

import { useStore } from 'effector-react';

import { AuthService } from 'services/Auth/AuthService';

import { authStore } from 'stores/AuthStore/AuthStore';

// A persisted browser session can outlive the server-side grant.
export default function useAccessManagement(enabled = true): boolean {
  const { token, permission, canManageFranchiseAccess } = useStore(authStore);
  const [verifiedToken, setVerifiedToken] = useState('');

  useEffect(() => {
    let active = true;
    setVerifiedToken('');
    if (enabled && token && permission === 0 && canManageFranchiseAccess === true) {
      AuthService.getUserInfo(token)
        .then(response => {
          const user = response?.data;
          if (active && user?.canManageFranchiseAccess === true) setVerifiedToken(token);
        })
        .catch(() => {
          if (active) setVerifiedToken('');
        });
    }
    return () => {
      active = false;
    };
  }, [enabled, token, permission, canManageFranchiseAccess]);

  return (
    enabled &&
    permission === 0 &&
    canManageFranchiseAccess === true &&
    !!token &&
    verifiedToken === token
  );
}
